import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { Max5xl, Max2xl, PX3, H1, P } from "../components/blocks"

class NotFoundPage extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO title="404: Not Found" />
        <Max5xl>
          <Max2xl>
            <PX3>
              <H1>Not Found</H1>
              <P>Unter dieser URL gibt es leider keine Seite.</P>
            </PX3>
          </Max2xl>
        </Max5xl>
      </Layout>
    )
  }
}

export default NotFoundPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
